module.exports = __webpack_public_path__ + "media/images/result_sets/icons/difficult_icon-cc2459d065c630cef2615191c4850fba.svg";